export enum damageReportResponsibilities {
  ownFault = 'ownFault',
  causedByThirdParty = 'causedByThirdParty',
  unknown = 'unknown',
}
